import React from 'react'
import PropTypes from 'prop-types'
import { Map, MapMarker } from 'components/common/GoogleMaps'

const LocationsMap = ({
  results = [],
  selectedItemIndex,
  onMapRefBecameAvailable,
  ...props
}) => {
  const { mapCenter } = results[0] || {}

  return <Map
    { ...props }
    defaultCenter={ mapCenter }
    defaultZoom={ results.length > 0 ? 12 : 4 }
    onRefAvailable={ onMapRefBecameAvailable }>
    {
      results
        .map(({ mapCenter, storeId }) =>
          <MapMarker
            key={ storeId }
            position={ mapCenter }
            asset={ selectedItemIndex === storeId ? 'marker-red-large' : 'marker-red-small' } />
        )
    }
  </Map>
}

export default LocationsMap

LocationsMap.propTypes = {
  onMapRefBecameAvailable: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.shape()),
  selectedItemIndex: PropTypes.string
}
